import { useState } from "react";
import { auth, db } from "./firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";

function LoginSignupPage({ onUserAuthenticated }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLogin, setIsLogin] = useState(true);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      let userCredential;
      if (isLogin) {
        userCredential = await signInWithEmailAndPassword(auth, email, password);
      } else {
        userCredential = await createUserWithEmailAndPassword(auth, email, password);

        // Create default profile in Firestore
        const defaultProfile = {
          name: "New Player",
          isDM: false,
          hp: { current: 10, max: 10 },
          ac: 10,
          speed: 30,
          bodyTemp: 50,
          hunger: 50,
          abilityScores: {
            STR: 10,
            DEX: 10,
            CON: 10,
            INT: 10,
            WIS: 10,
            CHA: 10,
          },
          skills: {
            Agility: 0,
            Athletics: 0,
            Crafting: 0,
            Discovery: 0,
            Perception: 0,
            Persuasion: 0,
            Survival: 0,
          },
          inventory: [],
        };

        await setDoc(doc(db, "profiles", userCredential.user.uid), defaultProfile);
      }

      onUserAuthenticated(userCredential.user);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
    onUserAuthenticated(null);
  };

  return (
    <div style={{ maxWidth: "400px", margin: "2rem auto", padding: "1rem" }}>
      <h2>{isLogin ? "Login" : "Sign Up"}</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={{ width: "100%", marginBottom: "0.5rem", padding: "0.5rem" }}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={{ width: "100%", marginBottom: "0.5rem", padding: "0.5rem" }}
        />
        <button type="submit" style={{ padding: "0.5rem 1rem" }}>
          {isLogin ? "Login" : "Sign Up"}
        </button>
      </form>

      <button onClick={() => setIsLogin(!isLogin)} style={{ marginTop: "1rem" }}>
        {isLogin ? "Don't have an account? Sign up" : "Already have an account? Login"}
      </button>

      {error && <div style={{ color: "red", marginTop: "1rem" }}>{error}</div>}

      <button onClick={handleLogout} style={{ marginTop: "2rem" }}>
        Logout
      </button>
    </div>
  );
}

export default LoginSignupPage;
